import { ElementProps, Flex, Text, UnstyledButton, UnstyledButtonProps } from '@mantine/core';
import { IconProps } from '@tabler/icons-react';
import { createElement, FunctionComponent } from 'react';
import styles from './styles.module.css';

interface MyUnstyledButtonProps
	extends UnstyledButtonProps,
		ElementProps<'button', keyof UnstyledButtonProps> {}

type TileButtonProps = MyUnstyledButtonProps & {
	icon: FunctionComponent<IconProps>;
	text: string;
};

export const TileButton = ({ icon, text, ...props }: TileButtonProps) => {
	return (
		<UnstyledButton component={'button'} {...props} className={styles.button}>
			<Flex justify="center" align="center" direction="column" gap="xs">
				<Flex justify="center" align="center" className={styles.circle}>
					{createElement(icon, { size: 52, color: 'var(--mantine-color-green-1)' })}
				</Flex>
				<Text ta="center" fw="900">
					{text}
				</Text>
			</Flex>
		</UnstyledButton>
	);
};
